import Notifications from './Notifications.vue';
import bus from '/src/utils/bus.js';

function notify (notification) {
	bus.emit('notifications:add', notification);
}

export {
	Notifications,
	notify,
};
